import { render, staticRenderFns } from "./recomanda.vue?vue&type=template&id=77f56be6&"
import script from "./recomanda.vue?vue&type=script&lang=js&"
export * from "./recomanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports